<template>
  <section>
    <top-menu/>
    <modal-password
      subtitle-modal="Informe a senha para acessar Notas Fiscais:"
      title-modal="Acesso - Notas Fiscais"
      :disabled-button="true"
      :remove-close-button="true"
      :run-function="handleAccess"
    />

    <section v-if="access">
      <page-header
        :header-name="'Notas Fiscais'"
        :show-btn="false"
        :btn-name="''"
        :btn-route="''"
        css="container-fluid"
      />

      <div class="page-content">
        <div class="container-fluid">
          <!-- Tabs -->
          <div class="notas-fiscais-tabs">
            <button
              :class="['tab-btn', { active: activeTab === 'emissao' }]"
              @click="activeTab = 'emissao'"
            >
              Emissão manual
            </button>
            <button
              :class="['tab-btn', { active: activeTab === 'historico' }]"
              @click="activeTab = 'historico'"
            >
              Histórico
            </button>
          </div>

          <!-- Emissão manual -->
          <div v-show="activeTab === 'emissao'" class="notas-fiscais-content">
            <full-loading v-if="loadingCompany || loadingEmit"/>

            <!-- Busca opcional de empresa -->
            <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
              <h3>Buscar dados da empresa (opcional)</h3>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Company ID</label>
                    <input v-model="searchCompany.companyId" type="text" class="form-control" placeholder="ID da empresa">
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Context Code</label>
                    <input v-model="searchCompany.contextCode" type="text" class="form-control" placeholder="ContextCode">
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <btn-custom col="12" label="Buscar dados da empresa" @emit-click="fetchCompanyData" :disabled="loadingCompany"/>
                </div>
              </div>
            </div>

            <!-- Formulário de emissão (key para atualizar inputs após pré-preenchimento) -->
            <div class="col-xs-12 col-sm-12 col-md-12 default-box filters" :key="'form-' + formKey">
              <h3>Dados para emissão da NF</h3>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Tipo de cobrança *</label>
                    <select v-model="form.billingType" class="form-control">
                      <option :value="0">MAM</option>
                      <option :value="1">BOH</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data de emissão *</label>
                    <datepicker
                      ref="datepickerEmission"
                      v-model="form.emissionDate"
                      :language="ptBR"
                      :format="customFormatter"
                    />
                    <i v-on:click="openDatepickerEmission()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Valor da NF *</label>
                    <input
                      v-model="form.value"
                      v-money="moneyConfig"
                      type="text"
                      class="form-control"
                      placeholder="0,00"
                    >
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Company ID *</label>
                    <input v-model="form.companyId" type="text" class="form-control" placeholder="ID da empresa">
                  </div>
                </div>
              </div>
              <div class="row">
                <input-text col="4" type="text" placeholder="CNPJ/CPF sem pontuação" label="CNPJ/CPF *" font-label="14px"
                            @contentText="value => form.cnpj = value" :value-default="form.cnpj"/>
                <input-text col="4" type="text" placeholder="Razão social" label="Razão social *" font-label="14px"
                            @contentText="value => form.name = value" :value-default="form.name"/>
                <input-text col="4" type="text" placeholder="E-mail fiscal" label="E-mail fiscal *" font-label="14px"
                            @contentText="value => form.email = value" :value-default="form.email"/>
              </div>
              <div class="row">
                <input-text col="2" type="text" placeholder="CEP" label="CEP *" font-label="14px"
                            @contentText="value => form.zipCode = value" :value-default="form.zipCode"/>
                <input-text col="2" type="text" placeholder="Número" label="Número *" font-label="14px"
                            @contentText="value => form.number = value" :value-default="form.number"/>
                <input-text col="4" type="text" placeholder="Logradouro" label="Logradouro *" font-label="14px"
                            @contentText="value => form.street = value" :value-default="form.street"/>
                <input-text col="2" type="text" placeholder="Cidade" label="Cidade *" font-label="14px"
                            @contentText="value => form.city = value" :value-default="form.city"/>
                <input-text col="2" type="text" placeholder="UF" label="Estado *" font-label="14px"
                            @contentText="value => form.state = value" :value-default="form.state"/>
              </div>
              <div class="row">
                <input-text col="4" type="text" placeholder="Bairro" label="Bairro *" font-label="14px"
                            @contentText="value => form.district = value" :value-default="form.district"/>
                <input-text col="4" type="text" placeholder="Telefone" label="Telefone *" font-label="14px"
                            @contentText="value => form.phone = value" :value-default="form.phone"/>
                <input-text col="4" type="text" placeholder="Complemento" label="Complemento" font-label="14px"
                            @contentText="value => form.complement = value" :value-default="form.complement"/>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4">
                  <div class="form-group">
                    <label>Reference ID (opcional)</label>
                    <div class="input-group">
                      <input v-model="form.referenceId" type="text" class="form-control" placeholder="Deixe vazio para o backend gerar">
                      <span class="input-group-btn">
                        <btn-custom col="12" label="Gerar ID" @emit-click="generateReferenceId"/>
                      </span>
                    </div>
                  </div>
                </div>
                <input-text col="8" type="text" placeholder="Observações" label="Observações" font-label="14px"
                            @contentText="value => form.notes = value" :value-default="form.notes"/>
              </div>
              <div class="row">
                <btn-custom col="12" label="Emitir NF" @emit-click="emitInvoice" :have-loading="true" :loading="loadingEmit"/>
              </div>
            </div>
          </div>

          <!-- Histórico -->
          <div v-show="activeTab === 'historico'" class="notas-fiscais-content">
            <full-loading v-if="loadingHistory"/>

            <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker
                      ref="datepickerInit"
                      v-model="historyFilters.dateInit"
                      :language="ptBR"
                      :format="customFormatter"
                    />
                    <i v-on:click="openDatepickerInit()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker
                      ref="datepickerEnd"
                      v-model="historyFilters.dateEnd"
                      :language="ptBR"
                      :format="customFormatter"
                    />
                    <i v-on:click="openDatepickerEnd()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-2">
                  <div class="form-group">
                    <label>Status</label>
                    <select v-model="historyFilters.success" class="form-control">
                      <option value="">Todos</option>
                      <option value="true">Sucesso</option>
                      <option value="false">Falha</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-2">
                  <div class="form-group">
                    <label>ID Empresa</label>
                    <input v-model="historyFilters.companyId" type="text" class="form-control" placeholder="Opcional">
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-2">
                  <div class="form-group">
                    <label>Razão Social</label>
                    <input v-model="historyFilters.companyName" type="text" class="form-control" placeholder="Opcional">
                  </div>
                </div>
              </div>
              <div class="row">
                <btn-custom col="12" label="Pesquisar" @emit-click="fetchHistory"/>
              </div>
            </div>

            <div v-if="!loadingHistory && historyList.length === 0 && historySearched" class="col-xs-12 default-box content-default">
              <p>Sem resultado na pesquisa.</p>
            </div>
            <div v-if="!loadingHistory && historyRequestFail" class="col-xs-12 default-box content-default">
              <p>Falha na requisição.</p>
            </div>

            <div v-if="!loadingHistory && historyList.length > 0" class="col-xs-12 default-box orderBy">
              <div class="portlet-title">
                <span class="caption-subject font-blue bold uppercase">Emissões manuais ({{ historyList.length }})</span>
              </div>
              <div class="portlet-body contate-table offset-top-20">
                <div class="table-scrollable table-scrollable-borderless">
                  <table class="table table-hover table-light table-icon">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Empresa</th>
                        <th>Quem fez</th>
                        <th>Método</th>
                        <th>Sucesso</th>
                        <th>Tempo (ms)</th>
                        <th>Resultado</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in historyList" :key="item.id">
                        <td>{{ formatDate(item.createdAt) }}</td>
                        <td>{{ item.companyName || item.companyId }}</td>
                        <td>{{ item.userName || '-' }}</td>
                        <td>{{ item.logIntegrationExternalMethodDescription || item.logIntegrationExternalMethod }}</td>
                        <td>{{ item.success ? 'Sim' : 'Não' }}</td>
                        <td>{{ item.processTime }}</td>
                        <td>{{ item.result || '-' }}</td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" @click="openPayloadModal(item)">
                            Ver payload
                          </button>
                          <template v-if="getReferenceIdFromItem(item)">
                            <button type="button" class="btn btn-sm btn-default" @click="fetchInvoiceDetail(item)" :disabled="loadingDetail">
                              Ver NF
                            </button>
                            <button type="button" class="btn btn-sm btn-danger" @click="cancelInvoice(item)" :disabled="loadingCancelId === item.id">
                              Cancelar NF
                            </button>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Modal detalhes da NF (Ver NF) -->
            <div class="modal fade" id="modal-detail-nf" role="dialog" tabindex="-1">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Detalhes da NF</h4>
                  </div>
                  <div class="modal-body">
                    <full-loading v-if="loadingDetail"/>
                    <div v-else-if="detailNf">
                      <p v-if="detailNf.url_danfse"><a :href="detailNf.url_danfse" target="_blank" rel="noopener">Abrir DANFSE</a></p>
                      <pre class="detail-nf-json">{{ JSON.stringify(detailNf, null, 2) }}</pre>
                    </div>
                    <p v-else>Nenhum dado carregado.</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal payload JSON (Ver payload) -->
            <div class="modal fade" id="modal-payload-json" role="dialog" tabindex="-1">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Payload (JSON)</h4>
                  </div>
                  <div class="modal-body">
                    <pre v-if="payloadModalJson" class="detail-nf-json" ref="payloadPre">{{ payloadModalJson }}</pre>
                    <p v-else>Nenhum conteúdo.</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="copyPayloadToClipboard">Copiar</button>
                    <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import BtnCustom from "../../../components/buttons/btnCustom.vue";
import inputText from "../../../components/inputs/inputText.vue";
import datepicker from "vuejs-datepicker";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import ModalPassword from "../../../modals/modalPassword.vue";
import moment from "moment";
import swal from "sweetalert";

import { REQUEST_SERVICE, UTIL_SERVICE } from "../../../../../requestConfig";
import {
  COMPANY_TO_REGISTER_INFOS,
  INVOICE_CREATE,
  INVOICE_LOGS,
  INVOICE_BY_REFERENCE,
  INVOICE_CANCEL,
} from "../../../../../urlConfig";

const PASSWORD_NOTAS_MANUAL = "notasManual";
const STORAGE_KEY_ACCESS = "notasManualAccess";
const TO_REGISTER_TOKEN = "83ff3cb222es847b485251d0d86DDe63f5";
// API retorna logIntegrationExternalMethod numérico: 2 = MAM, 3 = BOH
const MANUAL_METHOD_IDS = [2, 3];

export default {
  name: "notas-fiscais",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    BtnCustom,
    inputText,
    datepicker,
    ModalPassword,
  },
  data() {
    return {
      access: false,
      activeTab: "emissao",
      ptBR,
      loadingCompany: false,
      loadingEmit: false,
      loadingHistory: false,
      historyList: [],
      historySearched: false,
      historyRequestFail: false,
      searchCompany: {
        companyId: "",
        contextCode: "",
      },
      form: {
        billingType: 0,
        emissionDate: new Date(),
        value: "",
        companyId: "",
        cnpj: "",
        name: "",
        email: "",
        zipCode: "",
        number: "",
        street: "",
        city: "",
        state: "",
        district: "",
        phone: "",
        complement: "",
        notes: "",
        referenceId: "",
      },
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: true,
      },
      historyFilters: {
        dateInit: new Date(moment().subtract(30, "days")),
        dateEnd: new Date(),
        success: "",
        companyId: "",
        companyName: "",
        pageNumber: 1,
        pageSize: 25,
      },
      formKey: 0,
      detailNf: null,
      loadingDetail: false,
      loadingCancelId: null,
      payloadModalJson: null,
    };
  },
  mounted() {
    const stored = sessionStorage.getItem(STORAGE_KEY_ACCESS);
    if (stored === "1") {
      this.access = true;
    } else {
      $("#password-modal").modal("show");
    }
  },
  methods: {
    handleAccess(password) {
      if (!password) return;
      if (password.trim() === PASSWORD_NOTAS_MANUAL) {
        this.access = true;
        sessionStorage.setItem(STORAGE_KEY_ACCESS, "1");
        $("#password-modal").modal("hide");
      } else {
        swal("Aviso", "Senha incorreta.", "warning");
      }
    },
    customFormatter(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    openDatepickerEmission() {
      this.$refs.datepickerEmission && this.$refs.datepickerEmission.showCalendar();
    },
    openDatepickerInit() {
      this.$refs.datepickerInit && this.$refs.datepickerInit.showCalendar();
    },
    openDatepickerEnd() {
      this.$refs.datepickerEnd && this.$refs.datepickerEnd.showCalendar();
    },
    fetchCompanyData() {
      const { companyId, contextCode } = this.searchCompany;
      if (!companyId || !contextCode) {
        swal("Aviso", "Preencha Company ID e Context Code para buscar.", "warning");
        return;
      }
      this.loadingCompany = true;
      const url = `${COMPANY_TO_REGISTER_INFOS}?c=${encodeURIComponent(companyId)}&t=${TO_REGISTER_TOKEN}`;
      REQUEST_SERVICE.requestContext("GET", url, contextCode)
        .then((response) => {
          UTIL_SERVICE.console("ToRegisterInfos:", response.data);
          this.fillFormFromCompany(response.data);
          this.formKey += 1;
          swal("Sucesso", "Dados da empresa carregados. Você pode editar os campos antes de emitir.", "success");
        })
        .catch((err) => {
          const msg = err.response && err.response.data && (err.response.data.message || err.response.data.value);
          swal("Erro", msg || "Falha ao buscar dados da empresa.", "error");
        })
        .finally(() => {
          this.loadingCompany = false;
        });
    },
    fillFormFromCompany(data) {
      if (!data) return;
      const a = data.address || data.Address || {};
      const b = data.bussinessInfo || data.bussinessInfo || {};
      const p = data.phone || data.Phone || {};
      this.form.companyId = this.form.companyId || data.id || data.companyId || this.searchCompany.companyId;
      this.form.cnpj = (b.cnpj || data.cnpj || this.form.cnpj || "").toString().replace(/\D/g, "");
      this.form.name = data.representationName || data.name || data.razaoSocial || this.form.name || "";
      this.form.email = data.financialEmail || data.email || this.form.email || "";
      this.form.zipCode = (a.zipCode || data.zipCode || this.form.zipCode || "").toString().replace(/\D/g, "");
      this.form.number = (a.number || data.number || this.form.number || "").toString();
      this.form.street = a.street || data.street || this.form.street || "";
      this.form.city = a.city || data.city || this.form.city || "";
      this.form.state = (a.state || data.state || this.form.state || "").toString().substring(0, 2);
      this.form.district = a.neighborhood || a.district || data.district || this.form.district || "";
      this.form.phone = (p.phoneNumber || p.number || data.phone || this.form.phone || "").toString().replace(/\D/g, "");
      this.form.complement = a.complement || data.complement || this.form.complement || "";
    },
    generateReferenceId() {
      const guid = "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/x/g, () =>
        Math.floor(Math.random() * 16).toString(16)
      );
      this.form.referenceId = guid.toUpperCase();
    },
    getFormValueNumber() {
      if (!this.form.value || typeof this.form.value !== "string") return 0;
      const n = parseFloat(this.form.value.replace(/R\$\s|\.|,/g, (m) => (m === "," ? "." : "")));
      return isNaN(n) ? 0 : n;
    },
    validateForm() {
      const f = this.form;
      const required = [
        ["companyId", "Company ID"],
        ["cnpj", "CNPJ/CPF"],
        ["name", "Razão social"],
        ["email", "E-mail fiscal"],
        ["zipCode", "CEP"],
        ["number", "Número"],
        ["street", "Logradouro"],
        ["city", "Cidade"],
        ["state", "Estado"],
        ["district", "Bairro"],
        ["phone", "Telefone"],
      ];
      for (const [key, label] of required) {
        const v = (f[key] || "").toString().trim();
        if (!v) {
          swal("Aviso", `Preencha o campo: ${label}`, "warning");
          return false;
        }
      }
      const valueNum = this.getFormValueNumber();
      if (valueNum <= 0) {
        swal("Aviso", "O valor da NF deve ser maior que zero.", "warning");
        return false;
      }
      if (!f.emissionDate) {
        swal("Aviso", "Informe a data de emissão.", "warning");
        return false;
      }
      return true;
    },
    emitInvoice() {
      if (!this.validateForm()) return;
      this.loadingEmit = true;
      const f = this.form;
      const payload = {
        billingType: Number(f.billingType),
        emissionDate: moment(f.emissionDate).format("YYYY-MM-DDTHH:mm:ss"),
        value: this.getFormValueNumber(),
        companyId: f.companyId.trim(),
        cnpj: (f.cnpj || "").toString().replace(/\D/g, ""),
        name: (f.name || "").trim(),
        email: (f.email || "").trim(),
        zipCode: (f.zipCode || "").toString().replace(/\D/g, ""),
        number: (f.number || "").toString().trim(),
        street: (f.street || "").trim(),
        city: (f.city || "").trim(),
        state: (f.state || "").toString().trim().substring(0, 2),
        district: (f.district || "").trim(),
        phone: (f.phone || "").toString().replace(/\D/g, ""),
        complement: (f.complement || "").trim(),
        notes: (f.notes || "").trim(),
      };
      if ((f.referenceId || "").trim()) {
        payload.referenceId = f.referenceId.trim();
      }
      REQUEST_SERVICE.post(INVOICE_CREATE, payload)
        .then((response) => {
          const d = response.data || {};
          swal("Sucesso", (d.message || "NF emitida.") + (d.referenceId ? ` ReferenceId: ${d.referenceId}` : ""), "success");
        })
        .catch((err) => {
          const d = err.response && err.response.data;
          const msg = d && (d.message || (d.errorDetails && d.errorDetails.join && d.errorDetails.join(" ")));
          swal("Erro", msg || "Falha ao emitir NF.", "error");
        })
        .finally(() => {
          this.loadingEmit = false;
        });
    },
    fetchHistory() {
      const { dateInit, dateEnd, success, companyId, companyName, pageNumber, pageSize } = this.historyFilters;
      if (!dateInit || !dateEnd) {
        swal("Aviso", "Preencha data inicial e final.", "warning");
        return;
      }
      this.loadingHistory = true;
      this.historySearched = true;
      this.historyRequestFail = false;
      let url = `${INVOICE_LOGS}?dateInit=${moment(dateInit).format("YYYY-MM-DD")}&dateEnd=${moment(dateEnd).format("YYYY-MM-DD")}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
      if (success) url += `&success=${success}`;
      if (companyId) url += `&companyId=${encodeURIComponent(companyId)}`;
      if (companyName) url += `&companyName=${encodeURIComponent(companyName)}`;
      REQUEST_SERVICE.get(url)
        .then((response) => {
          const items = Array.isArray(response.data) ? response.data : (response.data && response.data.items) || response.data.data || [];
          this.historyList = items.filter(
            (item) => item.logIntegrationExternalMethod != null && MANUAL_METHOD_IDS.includes(Number(item.logIntegrationExternalMethod))
          );
        })
        .catch(() => {
          this.historyRequestFail = true;
          this.historyList = [];
        })
        .finally(() => {
          this.loadingHistory = false;
        });
    },
    formatDate(val) {
      if (!val) return "-";
      return moment(val).format("DD/MM/YYYY HH:mm");
    },
    // logIntegrationExternalMethod: 2 = MAM (billingType 0), 3 = BOH (billingType 1)
    getBillingTypeFromLog(item) {
      const m = Number(item.logIntegrationExternalMethod);
      if (m === 2) return 0;
      if (m === 3) return 1;
      return 0;
    },
    getReferenceIdFromItem(item) {
      if (!item || !item.json) return null;
      try {
        const data = typeof item.json === "string" ? JSON.parse(item.json) : item.json;
        return data.ReferenceId || data.referenceId || data.ReferenceID || null;
      } catch (e) {
        return null;
      }
    },
    fetchInvoiceDetail(item) {
      const referenceId = this.getReferenceIdFromItem(item);
      if (!referenceId) {
        swal("Aviso", "ReferenceId não encontrado neste registro.", "warning");
        return;
      }
      const billingType = this.getBillingTypeFromLog(item);
      this.loadingDetail = true;
      this.detailNf = null;
      const url = `${INVOICE_BY_REFERENCE}?referenceId=${encodeURIComponent(referenceId)}&billingType=${billingType}`;
      REQUEST_SERVICE.get(url)
        .then((response) => {
          this.detailNf = response.data || {};
          $("#modal-detail-nf").modal("show");
          if (this.detailNf.url_danfse) {
            // opcional: abrir em nova aba
          }
        })
        .catch((err) => {
          const msg = err.response && err.response.data && (err.response.data.message || err.response.data.value);
          swal("Erro", msg || "Falha ao consultar NF.", "error");
        })
        .finally(() => {
          this.loadingDetail = false;
        });
    },
    cancelInvoice(item) {
      const referenceId = this.getReferenceIdFromItem(item);
      if (!referenceId) {
        swal("Aviso", "ReferenceId não encontrado neste registro.", "warning");
        return;
      }
      if (!confirm("Confirma o cancelamento desta NF?")) return;
      const billingType = this.getBillingTypeFromLog(item);
      this.loadingCancelId = item.id;
      const url = `${INVOICE_CANCEL}?referenceId=${encodeURIComponent(referenceId)}&billingType=${billingType}`;
      REQUEST_SERVICE.post(url)
        .then(() => {
          swal("Sucesso", "NF cancelada com sucesso.", "success");
          this.fetchHistory();
        })
        .catch((err) => {
          const msg = err.response && err.response.data && (err.response.data.message || (err.response.data.errorDetails && err.response.data.errorDetails.join && err.response.data.errorDetails.join(" ")));
          swal("Erro", msg || "Falha ao cancelar NF.", "error");
        })
        .finally(() => {
          this.loadingCancelId = null;
        });
    },
    openPayloadModal(item) {
      if (!item || item.json == null) {
        this.payloadModalJson = "";
      } else {
        try {
          const parsed = typeof item.json === "string" ? JSON.parse(item.json) : item.json;
          this.payloadModalJson = JSON.stringify(parsed, null, 2);
        } catch (e) {
          this.payloadModalJson = typeof item.json === "string" ? item.json : JSON.stringify(item.json);
        }
      }
      this.$nextTick(() => $("#modal-payload-json").modal("show"));
    },
    copyPayloadToClipboard() {
      if (!this.payloadModalJson) return;
      const el = this.$refs.payloadPre;
      if (el && el.textContent) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(el.textContent).then(() => {
            swal("Sucesso", "Conteúdo copiado.", "success");
          }).catch(() => {
            this.fallbackCopy(el.textContent);
          });
        } else {
          this.fallbackCopy(el.textContent);
        }
      }
    },
    fallbackCopy(text) {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        swal("Sucesso", "Conteúdo copiado.", "success");
      } catch (e) {
        swal("Aviso", "Não foi possível copiar.", "warning");
      }
      document.body.removeChild(ta);
    },
  },
};
</script>

<style lang="scss" scoped>
.notas-fiscais-tabs {
  margin-bottom: 20px;
  .tab-btn {
    padding: 10px 20px;
    margin-right: 8px;
    border: 1px solid #ddd;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
    &.active {
      background: #337ab7;
      color: #fff;
      border-color: #337ab7;
    }
  }
}
.notas-fiscais-content {
  .filters h3 {
    margin-top: 0;
    margin-bottom: 16px;
  }
  .input-with-date {
    width: 100%;
    input {
      width: 100%;
    }
  }
}
.detail-nf-json {
  max-height: 400px;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/payment/notasFiscais/NotasFiscais.vue